export const membersFilterFunction = (item, filterString) => {
  const { firstName, lastName, email, mainPhoneNumber } = item;
  return (!!lastName && lastName.toLowerCase().includes(filterString)) ||
    (!!firstName && firstName.toLowerCase().includes(filterString)) ||
    (!!email && email.toLowerCase().includes(filterString)) ||
    (!!mainPhoneNumber && mainPhoneNumber.includes(filterString));
};
